import { useState } from 'react';

export default function useCollection(initial = null) {
  const [collection, setCollection] = useState(initial);

  return {
    collection,
    setCollection: (v) => {
      setCollection((v === null) ? v : v?.copy());
    },
  };
}
